import { getAuthStorageKey } from './get-auth-storage-key';

export const getStoredAuthToken = (brand: string) => {
  if (!localStorage) {
    return null;
  }

  return localStorage.getItem(getAuthStorageKey(brand));
};
